import { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

export const FacilityScreenContainer = (props: ComponentProps<'div'>) => {
  return <div {...props} className={twMerge(props.className, 'flex flex-1 flex-col w-full z-0 isolate')} />
}
